import { useQuery } from '@tanstack/react-query';
import type { VehicleByRegistrationNumber } from '@//app/api/protected/vehicle/lookup/registration-number/[registrationNumber]';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../httpClient';

export const VEHICLE_BY_REGISTRATION_NUMBER_RATE_LIMITED_CACHE_KEY =
  'api/vehicle/lookup/registration-number/:registrationNumber';

const useVehicleByRegistrationNumberRateLimited = (registrationNumber?: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<VehicleByRegistrationNumber>({
    queryKey: [
      VEHICLE_BY_REGISTRATION_NUMBER_RATE_LIMITED_CACHE_KEY,
      registrationNumber?.toLowerCase(),
    ],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/vehicle/lookup/registration-number/${registrationNumber}`;
      return await httpClientGetJson<VehicleByRegistrationNumber>(url);
    },
    enabled: !!registrationNumber,
  });

  return query;
};

export default useVehicleByRegistrationNumberRateLimited;
